The details of the uploaded candidate profile that was updated.

The uploaded candidate is available in the `candidate` field.
